import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { CotacaoTodosItensComponent } from './cotacao-todos-itens/cotacao-todos-itens.component';
import { CotacaoComponent } from './cotacao/cotacao.component';
import { ListaCotacoesComponent } from './lista-cotacoes/lista-cotacoes.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'lista-cotacoes',
    component: ListaCotacoesComponent
  },
  {
    path: 'cotacao/:cdFilial/:nrSolicitacao',
    component: CotacaoComponent
  },
  {
    path: 'cotacao-todos-itens',
    component: CotacaoTodosItensComponent
  },

  {
    path: 'portalcliente/cliente/cotacao/:cdFilial/:nrSolicitacao',
    redirectTo: 'cotacao/:cdFilial/:nrSolicitacao'
  },
  {
    path: 'portalcliente/cliente/cotacoes',
    redirectTo: 'lista-cotacoes'
  },

  { path: '**', redirectTo: 'home' }
];
